import React from "react";
import { Box, Typography, IconButton } from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import logo from "../assets/mealno-brand-logo.svg"; // Changed to use your main clean logo

export default function Footer() {
  return (
    <Box
      sx={{
        bgcolor: "#FFFDF8", // 🎨 Theme: Soft creamy background
        borderTop: "1px solid #ECE5DA", // 🎨 Theme: Soft oat border
        mt: 6,
      }}
    >
      <Box sx={{ maxWidth: "600px", mx: "auto", px: { xs: 2, sm: 3, md: 4 }, py: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-start", gap: { xs: 6, sm: 8 }, mb: 2 }}>
          {/* Logo + Slogan */}
          <Box>
            <Box
              component="img" src={logo} alt="Mealno"
              sx={{ height: { xs: 40, sm: 44 }, width: "auto", objectFit: "contain", mb: 1 }}
            />
            <Typography sx={{ mt: 0.5, fontSize: { xs: "0.75rem", sm: "0.8rem" }, color: "#6E655E", lineHeight: 1.5, fontWeight: '600' }}>
              Fresh Food.<br />
              Fast Delivery.
            </Typography>
          </Box>

          {/* Contact */}
          <Box sx={{ textAlign: "left" }}>
            <Typography sx={{ fontSize: { xs: "0.85rem", sm: "0.9rem" }, fontWeight: 800, color: "#3A2C23", mb: 1 }}>
              Contact Us
            </Typography>
            <Typography sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" }, color: "#6E655E", mb: 0.5, fontWeight: 500 }}>
              New Town, Kolkata
            </Typography>
            <Typography sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" }, color: "#6E655E", mb: 0.5, fontWeight: 500 }}>
              +91 70030 57695
            </Typography>
            <Typography sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" }, color: "#6E655E", fontWeight: 500 }}>
              support@mealno.in
            </Typography>
          </Box>
        </Box>

        {/* Social Icons */}
        <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 2, mt: 4 }}>
          <IconButton
            component="a"
            href="https://www.facebook.com/share/19EkhbJL29/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#A59D96", bgcolor: "#FFF6DE", "&:hover": { color: "#3A2C23", bgcolor: "#F8C332" } }}
          >
            <FacebookIcon fontSize="small" />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.instagram.com/mealno.in"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#A59D96", bgcolor: "#FFF6DE", "&:hover": { color: "#3A2C23", bgcolor: "#F8C332" } }}
          >
            <InstagramIcon fontSize="small" />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.linkedin.com/company/mealno.in/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#A59D96", bgcolor: "#FFF6DE", "&:hover": { color: "#3A2C23", bgcolor: "#F8C332" } }}
          >
            <LinkedInIcon fontSize="small" />
          </IconButton>

          <IconButton
            component="a"
            href="https://wa.me/917003057695"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#A59D96", bgcolor: "#FFF6DE", "&:hover": { color: "#3A2C23", bgcolor: "#F8C332" } }}
          >
            <WhatsAppIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      {/* Copyright */}
      <Box sx={{ borderTop: "1px solid #ECE5DA", py: 0.2, px: 2, textAlign: "center" }}>
        <Typography variant="caption" sx={{ color: "#A59D96", fontWeight: '600' }}>
          © 2026 Mealno · Made with in Kolkata, India.
        </Typography>
      </Box>

      {/* Version */}
      <Box sx={{ mb: 10, textAlign: "center" }}>
        <Typography variant="caption" sx={{ color: "#A59D96", fontWeight: '600' }}>
          v1.0.0.0
        </Typography>
      </Box>

    </Box>
  );
}